import { render } from "./branch-choose.vue?vue&type=template&id=6b74b972"
import script from "./branch-choose.vue?vue&type=script&lang=js"
export * from "./branch-choose.vue?vue&type=script&lang=js"

import "./branch-choose.vue?vue&type=style&index=0&id=6b74b972&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__